export default __webpack_public_path__ + "static/media/WP.9ffa5c02.gif";